<script>
import AssetDashboardCard from "@/Widgets/Cards/AssetDashboardCard.vue";

export default {
  name: "DevicesOverTime",
  components: {AssetDashboardCard},
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    yAxisKey: {
      type: String,
      default: 'cumulative_total',
    },
    loading: Boolean,
  },
  computed: {
    getTitle() {
      return this.title ?? this.$t('common.devices');
    },
    getSubtitle() {
      return this.subtitle ?? this.$t('widgets.charts.devices_over_time.added_to_sums_over_time');
    }
  },
  data() {
    return {
      chartData: [],
      chartOptions: [],
    }
  },
  methods: {
    setChartData() {
      const documentStyle = getComputedStyle(document.documentElement);
      return {
        datasets: [
          {
            label: this.$t('widgets.charts.devices_over_time.total_devices'),
            data: this.data,
            fill: true,
            borderColor: documentStyle.getPropertyValue('rgb(var(--primary-500))'),
            backgroundColor: documentStyle.getPropertyValue('rgb(var(--primary-500))'),
            tension: 0.4
          },
        ]
      };
    },
    setChartOptions() {
      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue('--text-color');
      const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
      const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

      return {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        parsing: {
          xAxisKey: 'date',
          yAxisKey: this.yAxisKey,
        },
        plugins: {
          legend: {
            display: false,
            labels: {
              color: textColor
            }
          }
        },
        scales: {
          x: {
            type: 'time',
            // suggestedMin: '2023-10-01',
            // suggestedMax: Date.now(),
            time: {
              unit: 'day',
              tooltipFormat: 'MMM D, YY'
            },
            title: {
              display: false,
              text: this.$t('common.date'),
            },
            ticks: {
              color: textColorSecondary,
            },
            grid: {
              color: surfaceBorder
            }
          },
          y: {
            ticks: {
              color: textColorSecondary,
              precision: 0
            },
            grid: {
              color: surfaceBorder
            }
          }
        }
      };
    }
  },
  watch: {
    data: {
      handler: function (newValue, oldValue) {
        this.chartData = this.setChartData();
      },
      immediate: true
    }
  },
  mounted() {
    this.chartOptions = this.setChartOptions();
  }
}
</script>

<template>
  <AssetDashboardCard
      :title="getTitle"
      :subtitle="getSubtitle"
      :loading="loading"
  >
      <Chart type="line" :data="chartData" :options="chartOptions"/>
  </AssetDashboardCard>
</template>

<style scoped>

</style>
